import React, { useState, useEffect } from "react";
import PasswordSetUp from "../../PasswordSetUp";
import { getUser } from "../../../redux/thunks/User";
import { useDispatch, useSelector } from "react-redux";
import { isWhiteLabelClient } from "../../../utils/utilities";
import Button from "../../../components/sub-component/Button";
import Emoji from "../../../assets/icons/onboarding/Emoji.svg";
import { getTanentProfile } from "../../../redux/thunks/UserProfile";
import ProcessingIndicator from "../../../components/common/ProcessingIndicator";

import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

function AssessmentConcluded({ assessment }) {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState(false);
  const [returnWL, setReturnWL] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [cachedDomain, setCachedDomain] = useState(null);
  const access_token = useSelector(
    (state) => state.authReducer?.data?.access_token,
  );
  const auth = useSelector((state) => state.authReducer);
  const tenantData = JSON.parse(localStorage.getItem("tenant_data"));
  const wlSettingsData = JSON.parse(localStorage.getItem("wl_settings_data"));

  useEffect(() => {
    const fetchUserProfile = async () => {
      setProcessing(true);
      try {
        const userResponse = await dispatch(
          getUser({ access_token: access_token }),
        );
        const user = userResponse?.payload;
        setUser(user);
        setProcessing(false);
      } catch (error) {
        console.error("Error fetching user profile:", error);
        setProcessing(false);
      }
    };
    fetchUserProfile();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmitPassword = async () => {
    setProcessing(true);
    localStorage.removeItem("tenant_data");
    // e.preventDefault();
    setPassword(true);
    setProcessing(false);
  };

  const handleSubmitWL = async () => {
    setProcessing(true);
    const domain = wlSettingsData?.domain ? wlSettingsData?.domain : "*";
    localStorage.removeItem("tenant_data");
    localStorage.removeItem("wl_assess_id");
    localStorage.removeItem("wl_client_id");
    localStorage.removeItem("wl_access_token");
    localStorage.removeItem("wl_refresh_token");
    localStorage.removeItem("wl_settings_data");
    setCachedDomain(domain);
    setReturnWL(true);
    setProcessing(false);
  };

  const handleSubmit = async () => {
    setProcessing(true);
    localStorage.removeItem("tenant_data");
    window.location.replace("/dashboard/assessments");
    setProcessing(false);
  };

  useEffect(() => {
    if (returnWL && cachedDomain) {
      window.parent.postMessage(
        {
          type: "ASSESSMENT_COMPLETED",
          payload: {
            message: "Assessment Completed",
          },
        },
        window._env_?.NODE_ENV === "production" ? cachedDomain || "*" : "*",
      );
    }
  }, [returnWL, cachedDomain]);

  return (
    <>
      {!password ? (
        <div className="candidate-assessment-flow-container">
          <div
            className="candidate-assment-flow-wrapper"
            style={{ height: "80vh" }}
          >
            <div
              className="d-flex flex-column align-items-center"
              style={{
                maxWidth: "664px",
                padding: "24px",
                gap: "24px",
                borderRadius: "24px",
                backgroundColor: "white",
              }}
            >
              <img
                src={Emoji}
                alt=""
                style={{ height: "60px", width: "60px", marginBottom: "-4px" }}
              />
              <span className={`headline-4 dark-100 text-center`}>
                Assessment Completed
              </span>
              <div
                className="d-flex flex-column align-items-start"
                style={{ gap: "24px" }}
              >
                <span className="body-2 text-start">
                  You have finished the assessment for the{" "}
                  <span className="semibold">{assessment?.title}</span> role.
                  The team at{" "}
                  <span className="semibold">{tenantData?.company_name}</span>{" "}
                  will now review your assessment.
                </span>
                <span className="body-2 text-start">
                  If you have any questions about the next steps, please reach
                  out to{" "}
                  <span className="semibold">{tenantData?.company_name}</span>.
                </span>
              </div>
              <div className="login-input-group d-flex justify-content-center">
                {loading ? (
                  <div style={{ height: "20px", width: "20px" }}>
                    <ProcessingIndicator />
                  </div>
                ) : (
                  <Button
                    themeRectangleButton
                    processing={
                      // isWhiteLabelClient() ? returnWL || processing :
                      processing
                    }
                    onClick={
                      isWhiteLabelClient()
                        ? handleSubmitWL
                        : user?.has_set_password === false
                          ? handleSubmitPassword
                          : handleSubmit
                    }
                    title={
                      isWhiteLabelClient()
                        ? "Continue"
                        : user?.has_set_password === false
                          ? "Set Up Password"
                          : "Go To Dashboard"
                    }
                    style={{ height: "52px", width: "184px" }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="watermark">
            {isWhiteLabelClient() ? (
              <></>
            ) : (
              <TestFuseWatermarkIcon style={{ height: "50px" }} />
            )}
          </div>
        </div>
      ) : (
        <PasswordSetUp assessment={assessment} access_token={access_token} />
      )}
    </>
  );
}

export default AssessmentConcluded;
